import { render, staticRenderFns } from "./PeepsAlertAbove.vue?vue&type=template&id=f5281cbe&scoped=true&"
import script from "./PeepsAlertAbove.vue?vue&type=script&lang=js&"
export * from "./PeepsAlertAbove.vue?vue&type=script&lang=js&"
import style0 from "./PeepsAlertAbove.vue?vue&type=style&index=0&id=f5281cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5281cbe",
  null
  
)

export default component.exports